/**
 * 从整卷正文中截取「当前锚块」：与索引构建逻辑一致（锚点标签之后到下一 <pb: 之前）
 */
export function extractPassage(fullText: string, anchorId: string): string {
  const i = fullText.indexOf(anchorId);
  if (i < 0) {
    return fullText.slice(0, 4000);
  }
  const afterTag = i + anchorId.length;
  const tail = fullText.slice(afterTag);
  const nextPb = tail.search(/<pb:[^>]+>/);
  const body = nextPb >= 0 ? tail.slice(0, nextPb) : tail;
  return body;
}
